export default {
  ADD_SNACKBAR_ITEM: 'ADD_SNACKBAR_ITEM',
  DISMISS_SNACKBAR_ITEM: 'DISMISS_SNACKBAR_ITEM',
}
